import { Component, Input } from '@angular/core';
import { TranslationsLibService } from '@nutricontrol/app360-shared';

@Component({
  selector: 'app-info-pill',
  templateUrl: './info-pill.component.html',
  styleUrls: ['./info-pill.component.scss'],
})
export class InfoPillComponent {
  @Input() type:
    | 'IRRIGATION'
    | 'CLIMATE'
    | 'DATALOGGER'
    | 'CONFIGURABLE'
    | 'UNKNOWN';
  @Input() class: string;
  @Input() height = '46px';
  @Input() value: number | string | undefined;
  @Input() dateTime: string | undefined;
  @Input() magnitudeLabel: string;
  @Input() magnitudeUnit: string;
  @Input() magnitudeTooltip: string | undefined;
  @Input() icon: string;
  @Input() virtual = false;
  @Input() hideIconOnMobile = true;

  constructor(public translationsLib: TranslationsLibService) {}

  formatDate(dateStr) {
    const date = new Date(dateStr);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  }
}
